import { render } from "./Note.vue?vue&type=template&id=0a82b32e&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"

import "./Note.vue?vue&type=style&index=0&id=0a82b32e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a82b32e"]])

export default __exports__